module.exports = __webpack_public_path__ + "75dadfaa047dac48b267078db4732545.png";